export default {
  modelName: 'auth',
  label: '使用者帳號',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    name: {
      type: 'text',
      label: '使用者名稱',
      rules: 'required',
      maxlength: 30,
    },
    email: {
      type: 'email',
      label: '帳號（email）',
      rules: 'required|email',
      maxlength: 50,
      note: '新增後不可修改',
      disabled: true,
      requiredField: 'name',
      conditionKeys: [
        {
          fieldName: 'name',
          conditionName: 'name',
        },
      ],
    },
    password: {
      type: 'password',
      label: '舊密碼',
      rules: 'required|min:6|nospace',
      updateNotNull: true,
      maxlength: 20,
      placeholder: '請輸入舊密碼',
    },
    new_password: {
      name: 'new_password',
      type: 'password',
      label: '新密碼',
      rules: 'required|min:6|nospace',
      updateNotNull: true,
      maxlength: 20,
      placeholder: '請輸入新密碼',
    },
    new_password_confirmation: {
      name: 'new_password_confirmation',
      type: 'password',
      label: '驗證新密碼',
      rules: 'required|min:6|nospace',
      updateNotNull: true,
      maxlength: 20,
      placeholder: '請再次輸入新密碼',
      compareStr: function(fields) {
        if (fields.new_password) {
          return fields.new_password;
        } else {
          return null;
        }
      },
    },
    fake_password: {
      type: 'password',
      label: '密碼',
      placeholder: '請輸入新密碼',
    },
    is_active: {
      type: 'switch',
      label: '啟用',
      defaultValue: false,
    },
    avatar: {
      type: 'image',
      label: '頭像',
      uploadUrl: '/user/avatar/',
      maxWidth: '114',
    },
    organizations: {
      type: 'hasMany',
      label: '所屬企業',
      textKey: 'name',
      modelName: 'organizations',
    },
    factories: {
      type: 'hasMany',
      label: '所屬工廠',
      textKey: 'name',
      modelName: 'factory',
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
  },
};
